import React from "react";
import PropTypes from "prop-types";
import { TvButton, TvDiv, TvSmall } from "@trustvid/design-system";
import { getSmartCampaignSamplePrompts } from "../constants/smartCampaignPromptGuide";

const AiCampaignSamplePrompts = ({
  activeMode = "empty",
  selectedSamplePromptId = null,
  onSelectPrompt = () => {},
  disabled = false,
  hasFiles = false,
}) => {
  const samples = getSmartCampaignSamplePrompts(activeMode);

  return (
    <TvDiv className="mb-2" data-testid="ai-campaign-sample-prompts">
      <TvSmall className="text-muted fw-semibold d-block mb-1">Sample prompts</TvSmall>
      {activeMode === "prompt-only" && !hasFiles ? (
        <TvSmall className="text-muted d-block mb-2">
          Brief-only works — AI may add stock visuals and music. Attach files to use your own media.
        </TvSmall>
      ) : null}
      <TvDiv className="d-flex flex-wrap gap-2">
        {samples.map((sample) => {
          const isSelected = selectedSamplePromptId === sample.id;
          return (
            <TvButton
              key={sample.id}
              type="button"
              color={isSelected ? "primary" : "outline-secondary"}
              size="sm"
              className={`text-start ${isSelected ? "fw-semibold" : ""}`}
              data-testid={`ai-campaign-sample-prompt-${sample.id}`}
              data-selected={isSelected ? "true" : "false"}
              aria-pressed={isSelected}
              disabled={disabled}
              onClick={() => onSelectPrompt(sample)}
            >
              {sample.label}
            </TvButton>
          );
        })}
      </TvDiv>
    </TvDiv>
  );
};

AiCampaignSamplePrompts.propTypes = {
  activeMode: PropTypes.oneOf(["empty", "uploads-only", "prompt-only", "uploads-and-prompt"]),
  selectedSamplePromptId: PropTypes.string,
  onSelectPrompt: PropTypes.func,
  disabled: PropTypes.bool,
  hasFiles: PropTypes.bool,
};

export default AiCampaignSamplePrompts;
